import { NotificationCard } from '../notification-card';
import ActionButton from './action-button';
import NotificationInternal from './notification-internal';
var NotificationNamespace = Object.assign(NotificationInternal, {
    ActionButton: ActionButton,
    CloseButton: NotificationCard.CloseButton,
});
export default NotificationNamespace;
